import { faTrash } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import ProductCard from 'Component/ProductCard';
import {
    WishlistItem as SourceWishlistItem
} from 'SourceComponent/WishlistItem/WishlistItem.component';

import './WishlistItem.override.style';

/** @namespace Elganso/Component/WishlistItem/Component */
export class WishlistItemComponent extends SourceWishlistItem {
    getWishlistProduct() {
        const {
            product
        } = this.props;

        return product;
    }

    renderRemove() {
        const { removeItem, product: { review_count } } = this.props;
        const withReview = review_count >= 1;

        return (
            <button
              block="WishlistItem"
              elem="Remove"
              mods={ { withReview } }
              onClick={ removeItem }
              aria-label={ __('Remove') }
            >
                <FontAwesomeIcon icon={ faTrash } />
            </button>
        );
    }

    render() {
        const { isLoading, isRemoving } = this.props;
        const product = this.getWishlistProduct();

        if (!product) {
            return null;
        }

        return (
            <div block="WishlistItem" elem="Box">
                { this.renderRemove() }
                <ProductCard
                  product={ product }
                  mix={ { block: 'WishlistItem', elem: 'ProductCard' } }
                  isLoading={ isLoading || isRemoving }
                  hideWishlistButton
                  hideCompareButton
                />
            </div>
        );
    }
}

export default WishlistItemComponent;
